import React from 'react';
import { Row, Col, Button, Space, Alert, Typography, Card, Image, notification } from 'antd';

import Vehicle from '../../../core/models/Vehicle';
import {
  inspectionApiSlice,
  useRegisterVehicleForInspectionMutation,
} from '../../../app/api/inspectionApiSlice';

const { Text } = Typography;
interface IProps {
  vehicle: Vehicle | null;
}

const ViewVehicleInspection: React.FC<IProps> = ({ vehicle }: IProps) => {
  const [registerVehicle, { isLoading: isRegisterLoading }] =
    useRegisterVehicleForInspectionMutation();

  const [trigger, { isLoading: isReportLoading }] =
    inspectionApiSlice.endpoints.getInspectionReport.useLazyQuery();

  const handleRegisterForInspection = (): void => {
    if (vehicle) {
      registerVehicle(vehicle.id)
        .unwrap()
        .then((res) => {
          notification.success({
            message: 'Register with grading system',
            description: 'Vehicle has been registered with the Grading System.',
          });
        })
        .catch((error) => {
          notification.error({
            message: 'Register with grading system',
            description: 'Failed to register vehicle with the Grading System.',
          });

          console.log(error);
        });
    }
  };

  const handleGenerateInspectionReport = (): void => {
    if (vehicle) {
      trigger(vehicle.id)
        .unwrap()
        .then((res) => {
          notification.success({
            message: 'Grading Report',
            description: 'Grading Report has been retrieved successfully.',
          });
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <>
      <Row>
        <Space>
          {!vehicle?.vid && (
            <Space direction='vertical'>
              <Alert message='This vehicle is not registered with Grading System.' type='info' />
              <br />
              <Text>Click below button to register vehicle for the Grading</Text>
              <Button
                type='primary'
                onClick={handleRegisterForInspection}
                loading={isRegisterLoading}
              >
                Register for Grading
              </Button>
            </Space>
          )}
          {vehicle?.vid && !vehicle?.inspectionReportUrl && (
            <Space direction='vertical'>
              <Alert message='Grading Report is not available for this vehicle.' type='warning' />
              <br />
              <Text>Click below button to retrieve Grading Report</Text>
              <Button
                type='primary'
                onClick={handleGenerateInspectionReport}
                loading={isReportLoading}
              >
                Retrieve Grading Report
              </Button>
            </Space>
          )}
          {vehicle?.inspectionReportUrl && (
            <Row>
              <Col>
                <Button type='link' href={vehicle?.inspectionReportUrl} target='_blank'>
                  View Full Screen
                </Button>
                <br />
                <iframe
                  width={600}
                  height={900}
                  src={`${vehicle?.inspectionReportUrl}?view=fitH`}
                ></iframe>
                <br />
                <br />
                <Text>
                  Click here to
                  <Button
                    type='link'
                    onClick={handleGenerateInspectionReport}
                    loading={isReportLoading}
                  >
                    Refresh
                  </Button>
                  Grading Report
                </Text>
                <br />
              </Col>
            </Row>
          )}
        </Space>
      </Row>
    </>
  );
};

export default ViewVehicleInspection;
